import React, { useRef, useState } from 'react';

function Reservation() {
  return (
    <section className='section'>
      <h5 className='skip'>Section Title</h5>
      <div className='section-inner'>Section Component</div>
    </section>
  );
}

export default Reservation;